<template>
    <div>
        <div class="headline">
            <h3>{{ 'Regions in ' + this.countryName }}</h3>
            <search
                :placeholder= "'Search for Regions in ' + countryName"
                icon="location-on"
                min_len = '3'
                v-on:searchstr="searchForRegions($event)">
            </search>

        </div>
        <div class="content">
            <loader v-if="countryName === ''"></loader>
            <p class="search-info" v-text="searchInfo"></p>
            <ul class="dashboard-box-list">
                <li v-for="(region, i) in visibleCountryRegions" :key="i">
                    <!-- Job Listing -->
                    <div class="job-listing">

                        <!-- Job Listing Details -->
                        <div class="job-listing-details">

                            <!-- Logo -->
                            <a href="#" class="job-listing-company-logo">
                                <img :src="flagUrl()" :alt="`Flag of ${country.name}`">
                            </a>

                            <!-- Details -->
                            <div class="job-listing-description">
                                <h3 class="job-listing-title">
                                    <span class="country-name" v-text="region.name"></span>
                                    <span class="country-info"  v-text="country.sortname"></span>
                                    <i class="country-info icon-feather-phone-call margin-left-4"></i>
                                    <span class="country-info margin-left-4">{{ `+${country.phonecode}` }}</span>
                                </h3>

                                <div class="job-listing-footer">
                                    <ul>
                                        <li><a :href="'/admin/location/cities?region=' + region.id" ><i class="icon-material-outline-location-city"></i> View Cities</a></li>
                                        <li><a :href="`/admin/location/users?region=${region.id}`"><i class="icon-material-outline-group"></i> View Users</a></li>
                                        <li><a :href="`/admin/location/projects?region=${region.id}`"><i class="icon-material-outline-business-center"></i> View Projects</a></li>
                                    </ul>


                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>

</template>
<script>
    import {getRegionsForCountries} from '../../../../core/services/location-services'
    import Search from "../../../partials/Search"
    import Loader from "../../../partials/Loader";

    export default {
        name: 'regions-in-country',
        props: ['countryId'],
        components: {Loader, Search},
        data() {
            return {
                country: '',
                countryName: '',
                countryRegions: '',
                visibleCountryRegions: '',
                searchInfo: '',
            }
        },

        computed: {
          name() {
              return ``;
          },
        },

        methods : {
            populateRegions() {
                getRegionsForCountries(this.countryId)
                    .then((country) => {
                        this.country = country;
                        this.countryRegions = country.regions;
                        this.visibleCountryRegions = country.regions;
                        this.countryName = country.name;
                    })
                    .catch(() => {
                        // console.log(error);
                    })
                    .finally(() => {

                    });

            },
            flagUrl() {
                return `https://flagcdn.com/56x42/${this.country.sortname.toLowerCase()}.png`;
            },
            searchForRegions(str) {
                this.searchInfo = '';
                if(str.length === 0) {
                    this.visibleCountryRegions = this.countryRegions;
                }
                let searchedRegion = [];
                this.countryRegions.forEach((region) => {
                    if((region.name.toLowerCase().search(str.toLowerCase())) !== -1) {
                        searchedRegion.push(region)
                    }
                });
                this.visibleCountryRegions = searchedRegion;
                if (searchedRegion.length < 1) {
                    this.searchInfo = `No Region in ${this.countryName} Matches Your Search Term: '${str}'`;
                }

            }
        },

        created() {
            this.populateRegions();
            if(window.innerWidth >= this.twoPaneLimit) {
                this.twoPane = true;
            }

        }
    }
</script>

<style scoped>
    .country-info {
        font-size: .7rem;
        color: #0fbaf1 !important;
    }
    .country-name {
        text-transform: uppercase;
        color: black;
    }
    .country-name::after {
        content: " ";
    }
    .search-info {
        margin: 0 auto;
        text-align: center;
        color: #0fbaf1 !important;
    }
</style>
